
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/university/booking",
      function () {
        return require("private-next-pages/university/booking.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/university/booking"])
      });
    }
  